var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ca-solar-wrapper" }, [
    _vm.active
      ? _c("div", {
          directives: [{ name: "dynamic-color", rawName: "v-dynamic-color" }],
          key: "ca-solar",
          staticClass: "ca-solar",
          class: _vm.visibilityClass,
        })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }